import React, { Component } from "react";
import { connect } from "react-redux";
import isArray from "../../../../function/isArray";

// CSS
import "../../../../css/SubOptionsLv2ExtraDescription.css";

export class SubOptionsLv2ExtraDescription extends Component {
  render() {
    const { lv2Default, ui, activeOptionIndex } = this.props;
    const subitems = ui.options[activeOptionIndex].option.display.lv2.subitems;
    let extraDescription = "";
    if (isArray(subitems)) {
      const activeSubitem = subitems.find(item => item.code === lv2Default);
      if (activeSubitem) extraDescription = activeSubitem.extraDescription;
    }
    return <div className="sub_options_lv2_extra_description">{extraDescription}</div>;
  }
}

const mapStateToProps = state => {
  return {
    lv2Default: state.product.lv2Default,
    ui: state.product.ui,
    activeOptionIndex: state.product.activeOptionIndex
  };
};

const mapDispatchToProps = () => {
  return {};
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SubOptionsLv2ExtraDescription);
